import { render } from "./MultiFillBlank.vue?vue&type=template&id=64f0df81"
import script from "./MultiFillBlank.vue?vue&type=script&lang=js"
export * from "./MultiFillBlank.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__